'use strict';

var Accordion = require('./Accordion.js');
var Masonry = require('masonry-layout');
var Debouncer = require('../lib/Debouncer.js');
var $ = require('jquery');

function init() {
	if (!document.getElementsByClassName('box').length)
		return;

	var that = this;

	that.myAccordion = new Accordion({
		item: 'box',
		doStartOpen: true
	});


	function boxHandling() {
		var isMobile = window.innerWidth <= 730;

		if (isMobile) {
			// Activate accordion
			if (!that.myAccordion.active) {
				that.myAccordion.init();
			}

			// Deactivate Masonry
			if (that.msnry) {
				for (var i=0; i < that.msnry.length; i++) {
					that.msnry[i].destroy();
				}
				that.msnry = null;
			}
		} else {
			// Deactivate accordion
			if (that.myAccordion.active) {
				that.myAccordion.destroy();
			}

			// Activate Masonry
			if (!that.msnry) {
				that.msnry = [];
				var elements = document.querySelectorAll('.boxGroup__boxes--col1 .box__contents');
				if (elements.length > 0) {
					that.msnry.push(new Masonry('.boxGroup__boxes--col1 .box__contents', {percentPosition: true, horizontalOrder: true}));
				}
				elements = document.querySelectorAll('.boxGroup__boxes--masonry');
				if (elements.length > 0) {
					that.msnry.push(new Masonry('.boxGroup__boxes--masonry', {percentPosition: true, horizontalOrder: true}));
				}
			}
		}
	}

	window.addEventListener('load', boxHandling);
	$(document).on('jsfAjaxAlways', boxHandling);

	var resizeDebouncer = new Debouncer(boxHandling);
	window.addEventListener('resize', resizeDebouncer.run);
}



module.exports = {
	init: init
};
